// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const CustomerSummary = t.struct({
    ckcId: t.String,
    displayName: t.String,
    id: t.String
}, {
    name: 'CustomerSummary',
    strict: true
});

export const getDefaultState = () => new CustomerSummary({
    ckcId: '',
    displayName: '',
    id: ''
});

export default CustomerSummary;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/customer-summary.js